import { render, staticRenderFns } from "./other-message-info.vue?vue&type=template&id=7e9030e2&"
import script from "./other-message-info.vue?vue&type=script&lang=js&"
export * from "./other-message-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports